// The language a Circle meets in, as `circles.language` stores it: a BCP-47
// primary language subtag with an optional region — `en`, `fr-CA`, `es-419`
// (a UN M.49 numeric region). Not the full BCP-47 grammar: no extlang, script,
// variant or extension subtags, and canonical case only (lowercase language,
// uppercase region), so a stored value and a directory `language` filter
// compare as plain strings.
//
// Lives in shared so every boundary admits one shape: Circle create/update
// and the directory filter. `Intl.DisplayNames#of` throws a RangeError on
// some tags outside this grammar (`en-12`, `zh-yue`), which is why the shape
// is enforced where the value enters rather than trusted as free text.
import { z } from 'zod';
export const LANGUAGE_TAG_PATTERN = /^[a-z]{2,3}(-([A-Z]{2}|\d{3}))?$/;
export const LanguageTagSchema = z.string().regex(LANGUAGE_TAG_PATTERN);
//# sourceMappingURL=language-tag.js.map